<template>
    <div id="telemetry">
        <span>D: {{ attitude.distanceValue }} {{ attitude.distanceUnit }}</span>
        <span>H: {{ attitude.heightValue }} {{ attitude.heightUnit }}</span>
        <span>H.S.: {{ velocity.horizontalValue }} {{ velocity.horizontalUnit }}</span>
        <span>V.S.: {{ velocity.verticalValue }} {{ velocity.verticalUnit }} <span v-html="this.velocity.verticalDirection"></span></span>
    </div>
</template>

<script>
  const dataUnavailable = 'N/A'

  export default {
    name: "Telemetry",
    data: () => ({
      // velocity specified via N-E-D (North-East-Down) coordinate system
      velocity: {
        verticalValue: dataUnavailable,
        verticalUnit: '',
        verticalDirection: '',
        horizontalValue: dataUnavailable,
        horizontalUnit: '',
      },
      attitude: {
        distanceValue: dataUnavailable,
        distanceUnit: '',
        heightValue: dataUnavailable,
        heightUnit: '',
        heading: '',
      },
    }),
    methods: {
      updateTelemetry(telemetry) {
        this.velocity.verticalValue = telemetry.velocity.verticalValue ? telemetry.velocity.verticalValue : dataUnavailable
        this.velocity.verticalUnit = telemetry.velocity.verticalUnit ? telemetry.velocity.verticalUnit : ''

        let verticalDirection = telemetry.velocity.verticalDirection ? telemetry.velocity.verticalDirection : ''

        if (verticalDirection === 'upward') {
          this.velocity.verticalDirection = '&#8593;'
        }
        if (verticalDirection === 'downward') {
          this.velocity.verticalDirection = '&#8595;'
        }
        if (verticalDirection === '') {
          this.velocity.verticalDirection = ''
        }

        this.velocity.horizontalValue = telemetry.velocity.horizontalValue ? telemetry.velocity.horizontalValue : dataUnavailable
        this.velocity.horizontalUnit = telemetry.velocity.horizontalUnit ? telemetry.velocity.horizontalUnit : ''
        this.attitude.distanceValue = telemetry.attitude.distanceValue ? telemetry.attitude.distanceValue : dataUnavailable
        this.attitude.distanceUnit = telemetry.attitude.distanceUnit ? telemetry.attitude.distanceUnit : ''
        this.attitude.heightValue = telemetry.attitude.heightValue ? telemetry.attitude.heightValue : dataUnavailable
        this.attitude.heightUnit = telemetry.attitude.heightUnit ? telemetry.attitude.heightUnit : ''
        this.attitude.heading = telemetry.attitude.heading ? telemetry.attitude.heading : ''
      }
    }
  }
</script>

<style scoped>

#telemetry {
    z-index: 20;
    color: white;
    font-size: 2em;
    display: grid;
    row-gap: 10px;
    column-gap: 3em;
    grid-template-columns: 1fr 1fr;
}

@media screen and (min-width: 320px) and (max-width: 1024px) {
    #telemetry {
        font-size: 1em;
    }
}

</style>
